import { render, staticRenderFns } from "./box5.vue?vue&type=template&id=447f510f&scoped=true&"
import script from "./box5.vue?vue&type=script&lang=js&"
export * from "./box5.vue?vue&type=script&lang=js&"
import style0 from "./box5.vue?vue&type=style&index=0&id=447f510f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447f510f",
  null
  
)

export default component.exports